/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ArrowRightOutlined, LoadingOutlined } from '@ant-design/icons';
import { CustomInput } from 'components/formik';
import { SIGNIN } from 'constants/routes';
import { Field, Form, Formik } from 'formik';
import { useDocumentTitle, useScrollTop } from 'hooks';
import PropType from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signUp } from 'redux/actions/authActions';
import { setAuthenticating, setAuthStatus } from 'redux/actions/miscActions';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import firebase from '../../../firebase/firebase';

const SignUp = ({ history }) => {
  const { t } = useTranslation();
  const { isAuthenticating, authStatus } = useSelector((state) => ({
    isAuthenticating: state.app.isAuthenticating,
    authStatus: state.app.authStatus
  }));
  const dispatch = useDispatch();
  const [companySwitch, setCompanySwitch] = useState(false);

  const SignUpSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('signInNotValidEmail'))
      .required(t('signInMandatoryEmail')),
    password: Yup.string()
      .required(t('signInMandatoryPassword'))
      .min(8, t('signUpNotValidPasswordLength'))
      .matches(/[A-Z\W]/g, t('signUpNotValidPassword')),
    fullname: Yup.string()
      .required(t('signUpMandatoryName'))
      .min(3, t('signUpNotValidName'))
      .max(60, t('accountNameError2')),
    iva: companySwitch
      ? Yup.string().required(t('signUpMandatoryIva'))
      : Yup.string(),
    representativeCode: Yup.string()
  });

  useScrollTop();
  useDocumentTitle(t('titleSignUp'));

  useEffect(
    () => () => {
      dispatch(setAuthStatus(null));
      dispatch(setAuthenticating(false));
    },
    []
  );

  const downloadPDF = async (fileName) => {
    const fileUrl = await firebase.getPDFLink(fileName);
    window.location.href = fileUrl;
  };

  const onClickSignIn = () => history.push(SIGNIN);

  const onFormSubmit = (form) => {
    if (!companySwitch)
      dispatch(
        signUp({
          fullname: form.fullname.trim(),
          email: form.email.trim().toLowerCase(),
          password: form.password.trim()
        })
      );
    else
      dispatch(
        signUp({
          fullname: form.fullname.trim(),
          email: form.email.trim().toLowerCase(),
          password: form.password.trim(),
          iva: form.iva.trim(),
          representativeCode: form.representativeCode.trim()
        })
      );
  };

  return (
    <div className="auth-content">
      {authStatus?.success && (
        <div className="loader">
          <h3 className="toast-success auth-success">
            {t(authStatus.message)}
            <LoadingOutlined />
          </h3>
        </div>
      )}
      {!authStatus?.success && (
        <>
          {authStatus?.message && (
            <h5 className="text-center toast-error">{t(authStatus.message)}</h5>
          )}
          <div
            className={`auth ${
              authStatus?.message && !authStatus?.success && 'input-error'
            }`}
          >
            <div className="auth-main">
              <h3>{t('signUpMessage')}</h3>
              <Formik
                initialValues={{
                  fullname: '',
                  email: '',
                  password: '',
                  iva: '',
                  representativeCode: ''
                }}
                validateOnChange
                validationSchema={SignUpSchema}
                onSubmit={onFormSubmit}
              >
                {() => (
                  <Form>
                    <div className="auth-field">
                      <Field
                        disabled={isAuthenticating}
                        name="fullname"
                        type="text"
                        label={`* ${t('signUpNameLabel')}`}
                        style={{ textTransform: 'capitalize' }}
                        component={CustomInput}
                      />
                    </div>
                    <div className="auth-field">
                      <Field
                        disabled={isAuthenticating}
                        name="email"
                        type="email"
                        label="* Email"
                        component={CustomInput}
                      />
                    </div>
                    <div className="auth-field">
                      <Field
                        disabled={isAuthenticating}
                        name="password"
                        type="password"
                        label="* Password"
                        component={CustomInput}
                      />
                    </div>
                    <br />
                    <input
                      id="company-switch"
                      type="checkbox"
                      checked={companySwitch}
                      onChange={() => setCompanySwitch(!companySwitch)}
                    />
                    <label htmlFor="company-switch">
                      <span>{t('companyRegistrationQuestion')}</span>
                    </label>
                    {companySwitch && (
                      <>
                        <div className="auth-field">
                          <Field
                            disabled={isAuthenticating}
                            name="iva"
                            type="text"
                            label="* IVA/VAT"
                            component={CustomInput}
                          />
                        </div>
                        <div className="auth-field">
                          <Field
                            disabled={isAuthenticating}
                            name="representativeCode"
                            type="text"
                            label={t('representativeCode')}
                            component={CustomInput}
                          />
                        </div>
                      </>
                    )}
                    <br />
                    <span>
                      *{t('registrationAcceptDocsMessage')}{' '}
                      <a
                        className="footer-link"
                        onClick={() => downloadPDF('PrivacyCookiePolicy.pdf')}
                      >
                        {'Privacy \u0026 Cookie Policy'}
                      </a>
                      /
                      <a
                        className="footer-link"
                        onClick={() => downloadPDF('TermsConditions.pdf')}
                      >
                        Terms and Conditions
                      </a>
                    </span>
                    <br />
                    <br />
                    <div className="auth-field auth-action auth-action-signup">
                      <button
                        className="button auth-button"
                        disabled={isAuthenticating}
                        type="submit"
                      >
                        {isAuthenticating
                          ? t('loadingMessage')
                          : t('signUpButton')}
                        &nbsp;
                        {isAuthenticating ? (
                          <LoadingOutlined />
                        ) : (
                          <ArrowRightOutlined />
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <div className="auth-message">
            <span className="auth-info">
              <strong>{t('signUpRegisterLabel')}</strong>
            </span>
            <button
              className="button button-small button-border button-border-gray"
              disabled={isAuthenticating}
              onClick={onClickSignIn}
              type="button"
            >
              {t('signInButton')}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

SignUp.propTypes = {
  history: PropType.shape({
    push: PropType.func
  }).isRequired
};

export default SignUp;
